import script from "./sw-form-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-form-editor.vue?vue&type=script&setup=true&lang=js"

import "./sw-form-editor.vue?vue&type=style&index=0&id=3d6618e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d6618e4"]])

export default __exports__